// extracted by mini-css-extract-plugin
export var audioPlayer = "_tq-0";